'use client';

import { AssociatedDealerBanner, Conditional } from 'components/pcc-components';
import { useTranslations } from 'next-intl';
import { ERRORS } from '../../constants/constants';
import { useFeedback } from 'providers/feedback-provider';

export const ErrorMessageBanner = () => {
  const { feedbackMessage, showFeedback } = useFeedback();
  const t = useTranslations();

  const getErrorMessage = () => {
    if (feedbackMessage === ERRORS.NO_RESULTS) {
      return t('SEARCH_GENERIC_NO_RESULTS');
    } else if (feedbackMessage === ERRORS.NO_SEARCH_VALUES) {
      return t('ADV_SEARCH_NULL_ERROR');
    } else if (feedbackMessage === ERRORS.INVALID_DCN) {
      return `${t('VALID_DCN_NO_STORES')} ${t(
        'VALID_DCN_NO_STORES_SYS_ADMIN'
      )}`;
    }
  };

  return (
    <Conditional test={showFeedback}>
      <AssociatedDealerBanner variant="error" ignoreScroll={true}>
        <p>{getErrorMessage()}</p>
      </AssociatedDealerBanner>
    </Conditional>
  );
};
